var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "likiee-icon",
    transform: "translate(-1284.335 -533.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M45.089,29.7a22.856,22.856,0,0,1-1.163,5.667c-2.845-4.609-2.877-11.554-1.6-14.409.368-.805.713-1.036.844-1.045h.054a.5.5,0,0,1,.361.189c.943.927,1.812,4.328,1.489,9.589",
    transform: "translate(1256.316 520.7)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M20.5,35.8a17.9,17.9,0,0,1-7.9-.649c.591-.753,1.205-1.578,1.793-2.442a41.888,41.888,0,0,0,2.9-4.965,5.39,5.39,0,0,0,2.738.117c4.388-.922,7.971-7.115,8.868-11.223.65-3.01,0-4.848-.7-5.845a4.359,4.359,0,0,0-2.823-1.89,4.8,4.8,0,0,0-3.352.695,1.7,1.7,0,1,0,1.735,2.923,1.436,1.436,0,0,1,1.046-.266.926.926,0,0,1,.581.438c.253.377.617,1.3.195,3.247-.76,3.442-3.719,8.076-6.256,8.6a1.852,1.852,0,0,1-.65.039A27.341,27.341,0,0,0,20.511,16.6c.169-2.809.27-9.642-2.524-12.386a3.847,3.847,0,0,0-3.07-1.153c-.887.068-2.543.555-3.68,3.033a18.06,18.06,0,0,0-1.026,9.008,20.466,20.466,0,0,0,3.511,9.837,9.474,9.474,0,0,0,.724.887,82.378,82.378,0,0,1-5.087,7.93A18,18,0,1,1,20.5,35.8",
    transform: "translate(1284.333 533.367)",
    fill: "#ff411a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconLarge);
export default __webpack_public_path__ + "static/media/logo-icon-large.55537b77.svg";
export { ForwardRef as ReactComponent };